//rafce
import React, {useState,useEffect,useRef,useMemo} from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Link, useNavigate } from "react-router-dom";
import Dialog from "../Dialog";
import MaterialReactTable from 'material-react-table';
import { ExcelExport,ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { process } from "@progress/kendo-data-query";
import { PDFExport } from '@progress/kendo-react-pdf';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import SideBar from "../sidebar/Sidebar";
import { toast } from 'react-toastify';
import RiseLoader from "react-spinners/RiseLoader";
import moment from "moment";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';


//DONT DELETE!!
// Sourch Code reference from : https://www.telerik.com/kendo-react-ui/components/excelexport/
//                    https://www.npmjs.com/package/material-react-table
const styleTittle = {

  fontSize: 20,
  color: "#4a54f1",
  textAlign: "center",
  paddingBottom: "20px",
  paddingTop: "5px",

}
const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const BarangKeluar = () => {

  const month = ["January","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
  const [loading, setLoading] = useState(true);

    const [barangkeluar,setBarangKeluar] = useState([]);
    const [cabang, setCabang] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState("");
    const [show, setShow] = useState(true);
    const navigate = useNavigate();
    const _exporter = React.createRef();
    const pdfExportComponent = React.useRef(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    

// START ---TOKEN--- 
const refreshToken = async() => {
  try {
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        // console.log("ini decode: ",decoded);
        setUsername(decoded.username);
        setCabang(decoded.cabang);
        setEmail(decoded.email);
        setRole(decoded.role);
        setExpire(decoded.exp);
        

  } catch (error) {
      if(error.response){
        navigate("/login");
      }
  }
}

useEffect(() => {
          refreshToken();
          if (cabang && role) {
              getBarangKeluar();
            }
      },[cabang, role]);

const axiosJWT = axios.create();

axiosJWT.interceptors.request.use(async(config) => {
    const curretDate = new Date();
    if(expire * 1000 < curretDate.getTime()){
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        // console.log(decoded);
        setUsername(decoded.username);
        setCabang(decoded.cabang);
        setEmail(decoded.email);
        setRole(decoded.role);
        setExpire(decoded.exp);
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// ----END---

const getBarangKeluar = async () => {
    const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/barangkeluar`,{
        params: {
                    cabang: cabang,
                    role :role
                },
        headers:{
            Authorization:`Bearer ${token}`
        }
    });
    // console.log("ini hasil get",response.data[0]);
    setBarangKeluar(response.data[0]);
    setLoading(false)
}

//DELETE
const idBarangRef = useRef();
const [dialog, setDialog] = useState({
    message:"",
    isLoading:false,
    namaBarang:""
});

const handleDialog = (message, isLoading, namaBarang)=> {
    setDialog({
        message,
        isLoading,
        namaBarang
    });
};

const handleDelete = (idBarangKeluar,namaBarang)=> {
    handleDialog("Yakin Ingin Hapus?",true,namaBarang);
    idBarangRef.current = idBarangKeluar;
    
};

const areUSureDelete = (choose) => {
    if (choose) {
      deletebarang(idBarangRef.current);   
      handleDialog("", false);
    } else {
      handleDialog("", false);
    }
  };

const deletebarang = async (idBarangKeluar) =>{
    try {
        await axios.delete(`${process.env.REACT_APP_MASTER_URL}/barangkeluar/${idBarangKeluar}`);
        getBarangKeluar();
        toast.info("Hapus Barang Berhasil");
    } catch (error) {
        toast.error("Hapus Gagal, Kesalahan Server");
        console.log(error);
        
    }
}
//---- DELETE END -----

  
  //Table
  const columns = useMemo(
    () => [
      
          {
            accessorKey: "kodeBarang", //simple recommended way to define a column
            header: "Kode Barang",
            muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
            Cell: ({ cell }) => <strong>{ cell.getValue() }</strong> //optional custom cell render
          },
      {
        accessorKey: "cabang", //simple recommended way to define a column
        header: "Cabang",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "namaBarang", //simple recommended way to define a column
        header: "Nama Barang",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "qty", //simple recommended way to define a column
        header: "Jumlah",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "pemohon", //simple recommended way to define a column
        header: "Pemohon",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "user", //simple recommended way to define a column
        header: "User",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "tanggal", //simple recommended way to define a column
        header: "Tanggal",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "keterangan", //simple recommended way to define a column
        header: "Ket.",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "#", //simple recommended way to define a column
        header: "Aksi",
        muiTableHeadCellProps: { sx: { color: "red" } },
         //custom props
        Cell: ( props ) => ( <> {show && <a>
                                        <button
                                            onClick={() => handleDelete(props.row.original.idBarangKeluar,props.row.original.namaBarang )}
                                            className="button is-small is-danger">
                                            Delete 
                                        </button>
                                </a> }
                            </>
                            ),
      },
    ],
    []
  ); 

  //Data Excel
  const data = process(barangkeluar,{}).data;
    const excelExport = () => {
      if (_exporter.current) {
        _exporter.current.save();
      }
    };

  //PDF
  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
    pdfExportComponent.current.save();
    }
    };

  const openModal = () => {
      setModalIsOpen(true);
    };
    
   const closeModal = () => {
      setModalIsOpen(false);
    };

   const handleStartDateChange = date => {
      setStartDate(date);
    };
  
    const handleEndDateChange = date => {
      setEndDate(date);
    };

    const columnspdf = [
      { title: "Kode Barang", field: "kodeBarang", },
      { title: "Nama Barang", field: "namaBarang", },
      { title: "Jumlah", field: "qty", },
      { title: "Pemohon", field: 'pemohon', },
      { title: "Tanggal", field: 'tanggal', },
      { title: "Keterangan", field: 'keterangan', },
    ]

    const downloadPdfByTgl = () => {
      const tanggalAwal = moment(startDate).format("DD-MM-YYYY"); // Tanggal awal
      const tanggalAkhir = moment(endDate).format("DD-MM-YYYY");  
      // console.log('INI TANGGAL: ', moment(startDate).format("DD-MM-YYYY"));
    
      const filteredBarang = barangkeluar.filter(item => {
        const itemDate = moment(item.tanggal, 'DD-MM-YYYY');
        // console.log('TANGGAL: ', itemDate);
        // console.log('TANGGAL Awal: ', moment(tanggalAwal,'DD-MM-YYYY'));
        return itemDate >= moment(tanggalAwal,'DD-MM-YYYY') && itemDate <= moment(tanggalAkhir,'DD-MM-YYYY');
      });

      const sortedBarang = filteredBarang.sort((a, b) => {
        const dateA = moment(a.tanggal, 'DD-MM-YYYY');
        const dateB = moment(b.tanggal, 'DD-MM-YYYY');
        return dateB.diff(dateA);
      });

      const reversedBarang = sortedBarang.reverse();
    
      const doc = new jsPDF();
      const logoImg = new Image();
      logoImg.src = `${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`;
    
      logoImg.onload = function () {
        // Menambahkan gambar ke PDF
        doc.addImage(logoImg, 'PNG', 17, 2, 30, 12);
    
        doc.setFontSize(14);
        doc.text("Laporan Stok Keluar", 102, 10, 'center');
        doc.text(`BPR Bank Nusamba JATIM CAB.${cabang}`, 102, 15, 'center');
        doc.setFontSize(10);
        doc.text(`Tanggal: ${tanggalAwal} s/d ${tanggalAkhir}`, 18, 27);
        doc.autoTable({
          theme: "grid",
          columns: columnspdf.map(col => ({ ...col, dataKey: col.field })),
          margin: { top: 30 },
          body: reversedBarang // Menggunakan filteredBarang sebagai data yang akan ditampilkan dalam tabel PDF
        });
    
        doc.save(`Laporan Stok Barang Keluar Nusamba Jatim CAB.${cabang} ${tanggalAwal} s/d ${tanggalAkhir}.pdf`);
      };
      closeModal();
    };
    
    

    const downloadPdf = () => {
      const doc = new jsPDF()
      const logoImg = new Image();
        
      logoImg.src = `${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`;

        logoImg.onload = function () {

          doc.addImage(logoImg, 'PNG', 15, 2, 30, 12);

          doc.text(`Laporan Stok Barang Keluar BPR Nusamba Jatim CAB.${cabang}`, 112, 10,'center')
          doc.setFontSize(10)
          doc.text(`Tanggal: ${new Date().getDate()} ${month[new Date().getMonth()]} ${new Date().getFullYear()}`,18, 27, )
          
          const sortedBarangKeluar = barangkeluar.sort((a, b) => {
            const dateA = new Date(a.tanggal).getTime();
            const dateB = new Date(b.tanggal).getTime();
            return dateB - dateA;
          });
          
          doc.autoTable({
            theme: "grid",
            columns: columnspdf.map(col => ({ ...col, dataKey: col.field })),
            margin: { top: 30},
            body: sortedBarangKeluar.reverse()
          })
          doc.save(`Laporan Stok Barang Keluar Nusamba Jatim CAB.${cabang} ${new Date().getDate()}-${month[new Date().getMonth()]}-${new Date().getFullYear()}.pdf`)
        }
    }
  
  return (
  <div>
      {loading ?
        <div style={stylespinner}>
          <RiseLoader
            color={'#301E67'}
            loading={loading}
            size={20}
            hidden={100}
            textAlign='centered'
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div> 
          :
      <SideBar>
      <div className="columnms mt-5 is centered">
        <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
        
              <label className='label' style={styleTittle}><center>DAFTAR BARANG KELUAR <p/>BPR NUSAMBA JATIM CAB.{cabang}</center></label>
              <Link to={'tambahbarangkeluar'} state={{ cabang: cabang }} className="button is-danger">Tambah Barang Keluar</Link>
              
              <button className="button is-link ml-5" onClick={downloadPdf}>
                Export to PDF
              </button>
              {role === 'superAdmin' && (
                <button className="button is-success ml-5" onClick={excelExport}>
                  Export to Excel
                </button>
              )}
              <button className="button is-warning ml-5" onClick={openModal}>
                Export to PDF by Tgl
              </button>
  
        
              <ExcelExport
                          data={data}
                          collapsible={true}
                          fileName={`Laporan Stok Barang Keluar ${new Date().getDay()}-${month[new Date().getMonth()]}-${new Date().getFullYear()}.xlsx`}
                          ref={_exporter}>
                          <ExcelExportColumn field="kodeBarang" title="Nama Nasabah" />
                          <ExcelExportColumn field="namaBarang" title="Nama Barang" width={200} />
                          <ExcelExportColumn field="qty" title="Jumlah" />
                          <ExcelExportColumn field="pemohon" title="Pemohon"/>
                          <ExcelExportColumn field="keterangan" title="Keterangan" />
                          <ExcelExportColumn field="tanggal" title="Tanggal" />
              </ExcelExport>

              <PDFExport
                  ref={pdfExportComponent}
                  paperSize="auto"
                  margin={40}
                  fileName={`List Barang Keluar ${new Date().getDay()}-${month[new Date().getMonth()]}-${new Date().getFullYear()}`}
                  author="KendoReact Team"
                >
                <div style={{ position: 'relative' }}>
                  {role === 'superAdmin' && (
                    <MaterialReactTable 
                      enableRowNumbers
                      rowNumberMode="original"
                      initialState={{ columnVisibility: { '#': true } }}
                      columns={columns}
                      data={barangkeluar} 
                      style={{ marginTop: '600px', position: 'relative', zIndex: '0' }}
                      defaultColumn={{
                        minSize: 10,
                        maxSize: 60,
                        size: 200,
                      }}
                    />
                  )}

                  {role === 'admin' && (
                    <MaterialReactTable 
                      enableRowNumbers
                      rowNumberMode="original"
                      initialState={{ columnVisibility: { '#': false } }}
                      columns={columns}
                      data={barangkeluar} 
                      style={{ marginTop: '600px', position: 'relative', zIndex: '0' }}
                      // enableStickyHeader
                      // enableStickyFooter
                      muiTableProps={{
                        sx: {
                          tableLayout: 'fixed',
                        },
                      }}
                      defaultColumn={{
                        minSize: 10,
                        maxSize: 140,
                        size: 260,
                      }}
                    />
                  )}

                  <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    overlayClassName="modal-overlay"
                    contentLabel="Export to PDF"
                    style={{
                      overlay: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      },
                      content: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -28%)',
                        width: '80%',
                        maxWidth: '300px',
                        maxHeight: '80%',
                        overflow: 'auto',
                        background: 'linear-gradient(135deg, #87CEEB, #1E90FF)',
                        zIndex: 1,
                      },
                    }}
                  >
                <div style={{ marginBottom: '10px' }}>
                  <h2 style={{ textAlign: 'center', fontWeight: 'bold' }}>Export to PDF</h2>
                </div>
                <div style={{marginBottom: '10px'}}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleStartDateChange}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Pilih Tanggal Awal"
                    className="datepicker-input"
                  />
                </div>
                <div>
                  <DatePicker
                    selected={endDate}
                    onChange={handleEndDateChange}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Pilih Tanggal Akhir"
                    className="datepicker-input"
                  />
                </div>
                <div style={{ marginTop: '50px',marginBottom: '90px', textAlign: 'center' }}>
                  <button className="button is-link" onClick={downloadPdfByTgl}>
                    Download PDF
                  </button>
                  <button className="button is-warning" style={{ marginLeft: '10px' }} onClick={closeModal}>
                    Batal
                  </button>
                </div>

              </Modal>
                </div>

              </PDFExport>
              {dialog.isLoading && (
                  <Dialog
                  //Update
                  nameProduct={dialog.namaBarang}
                  onDialog={areUSureDelete}
                  message={dialog.message}
                  />
                  )}     

      </div>
      </SideBar>
    }
  </div>
  )
}

export default BarangKeluar